// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".skeleton[data-v-18de4e34]{width:100%;background:#fff;border-radius:3px;position:relative;overflow:hidden;cursor:wait}.skeleton[data-v-18de4e34]:before{content:\"\";display:block;height:100%;max-width:300px;width:100%;background:linear-gradient(90deg,#fff,#ddd);position:absolute;top:0;left:0;animation:skeleton-animation-18de4e34 1.5s linear infinite}@keyframes skeleton-animation-18de4e34{0%{transform:translateX(-300px)}to{transform:translateX(300px)}}", ""]);
// Exports
module.exports = exports;
